module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Home')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7d0e644e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SpecialSauce.vue
// module id = 403
// module chunks = 1